// extracted by mini-css-extract-plugin
export default {"root":"EditListingIndustriesPanel_root__sLHpp","form":"EditListingIndustriesPanel_form__xDN5a","title":"EditListingIndustriesPanel_title__4V6ba"};